<template>
  <div class="prov">
    <div>
      <img src="/public/img/recursos/nufit_logo.png">
    </div>
  </div>
</template>

<style>
/* Generales */
.prov{
  background-image: url('/public/img/recursos/ricepaper.png');
  background-size:20% 100px;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.prov div{
  background-image: url('/public/img/recursos/bg_craft.png');
  padding: 100px;
  border-radius: 10px;
}
  .uk-modal.uk-open{
    z-index: 9999;
  }
  .mr{
    font-size: 7px;
    vertical-align: super;
  }
  sup, sub{
    font-size: 10px;
  }
  .paddingT80{
    padding-top: 80px;
  }
  .max600{
    max-width: 600px;
    display: block;
    margin: 0 auto;
  }
  .content{
    max-width: 940px;
    width: 66%;
  }
  .content1{
    max-width: 940px;
    width: 66%;
    margin: 0 auto;
  }
  .laterales{
    min-width: 250px;
    width: 17%;
    height: 300px;

  }
  .sublateral{
    background-image: url('/public/img/_img_hojas_1_izq.png');
    width: 100%;
    height: 100%;
    position: relative;
  }
  #bg1{
    background-image: url('/public/img/hoja.png');
  }
  #elemento1{
    position: absolute;
    right: 0px;
    z-index: 1;
  }
  .colorNaranja{
    color: #F68727;
  }
  .colorBlanco{
    color:white;
  }
  .colorCafe{
    color: #5E3C32;
  }
  .borderColorVerde, .borderColorVerde td{
    border-color: #86BB2B!important;
  }
  .borderColorMorado, .borderColorMorado td{
    border-color: #8A3087!important;
  }
  .title1{
    font-size: 60px;
    color: #5F3C31;
    font-family: 'Satisfy', cursive;
  }
  .title2{
    font-size: 20px;
    font-weight: bold;
    font-family: 'Montserrat', sans-serif;
  }
  .title3{
    font-size: 16px;
    color: #5E3C32;
    font-weight: bold;
    margin: 0px;
    font-family: 'Montserrat', sans-serif;
  }
  .title4{
    font-size: 20px;
    font-weight: bold;
    margin: 0px;
    font-family: 'Montserrat', sans-serif;
  }
  .title5{
    font-size: 18px;
    color: white;
    font-weight: bold;
    margin: 0px;
  }
  .title6{
    font-size: 35px;
    font-family: 'Satisfy', cursive;
  }
  .text1{
    font-size: 16px;
    z-index: 99;
    position: relative;
    margin-top: 0px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
  }
  
</style>
<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Menu from '../components/Nav.vue'
import Slider from '../components/Slider.vue'
import Cachorro from '../components/Cachorro.vue'
import CardBeneficios from '../components/CardBeneficios.vue'
export default {
  name: 'Home',
  mounted(){

  },
  components: {
    Menu,
    Slider,
    CardBeneficios,
    Cachorro
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Prov.vue